// extracted by mini-css-extract-plugin
export var main = "photos-module--main--7030y";
export var photo = "photos-module--photo--pA4ig";
export var photoBackground = "photos-module--photoBackground--k9K0X";
export var photoBackgroundBlurred = "photos-module--photoBackgroundBlurred--W+776";
export var photoDesc = "photos-module--photoDesc--lRNqG";